import React, { useEffect, useState } from "react";
import { Outlet, useOutlet } from "react-router-dom";
import styled from "styled-components";
import { getCurrentLocation } from "../util/util";
import UserController, { LocationType } from "../controller/UserController";

let getLocationTimer: any;

export const AllLayout = () => {
  const [position, setPosition] = useState<LocationType>({
    lng: 127.0452170666,
    lat: 37.5078630391,
  });

  // test
  // const userLogin = async () => {
  //   try {
  //     const oParams = {
  //       email: "demo@ivid.co.kr",
  //       phone_number: "01012341234",
  //       deviceuuid: "D8829145-1111-2222-3333-18707C30BA13",
  //       register_app: "obigo",
  //       marketingterms: "",
  //       car_license: "",
  //       device_os_info: "",
  //       smscode: "111111",
  //     };
  //     const oRes = await UserController.login(oParams);

  //     if (oRes && oRes.data) {
  //       console.log("login", oRes.data);
  //     }
  //   } catch (err) {
  //     console.log("err---->", err);
  //   }
  // };

  // 현재 위치 위도, 경도
  // const getLocation = () => {
  //   getCurrentLocation()
  //     .then((coords) => {
  //       setPosition({ lat: coords.latitude, lng: coords.longitude });
  //       console.log("getPosition", coords.latitude, coords.longitude);
  //     })
  //     .catch((error) => {
  //       console.error("Error getting location:", error);
  //     });
  // };

  useEffect(() => {
    // getLocation();
    // getLocationTimer = setTimeout(() => {
    //   getLocation();
    // }, 10000);
    // return () => {
    //   clearTimeout(getLocationTimer);
    // };
  }, []);

  return (
    <Style>
      <div className="screen">
        <Outlet
          context={{
            position: position,
          }}
        />
      </div>
    </Style>
  );
};

export const Style = styled.div`
  .screen {
    width: 100%;
    height: 100%;
    min-height: auto;
  }
`;
